import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/card/card-content.js'

const tagName = 'dap-ds-card-content'

/**
 * `dap-ds-card-content`
 * @summary A card content is a container for content in a card.
 * @element dap-ds-card-content
 * @title - Card content
 * @group card
 *
 * @property {'sm' | 'md' | 'lg'} size - The size of the card subtitle. Default is `sm`.
 * @property {'top' | 'bottom' | 'both' | 'none'} spacing - The spacing of the card content. This adds a margin to the card subtitle. Default is `bottom`.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg").
 *
 * @slot - The content of the card-content.
 *
 * @csspart base - The main card content container.
 *
 * @cssproperty --dds-card-content-padding - The padding of the card content. (default: 0)
 * @cssproperty --dds-card-content-margin - The margin of the card content. (default: 0)
 * @cssproperty --dds-card-content-font-size - The font size of the card content. (default: var(--dds-font-base))
 * @cssproperty --dds-card-content-line-height - The line height of the card content. (default: var(--dds-font-line-height-xlarge))
 * @cssproperty --dds-card-content-spacing-lg - The large spacing value. (default: var(--dds-spacing-600))
 * @cssproperty --dds-card-content-spacing-md - The medium spacing value. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-content-spacing-sm - The small spacing value. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-content-spacing-top - The top spacing value. (default: 0)
 * @cssproperty --dds-card-content-spacing-bottom - The bottom spacing value. (default: 0)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCardContent',
})

export default reactWrapper
